import React from 'react';

import {
  SectionConfigsMap,
  SectionWidgetConfig,
  WidgetsIdToSectionsIdMap,
} from './global-widget-config-types';

type State = {
  sectionConfigsMap: SectionConfigsMap;
  widgetIdToSectionIdMap: WidgetsIdToSectionsIdMap;
};

type Action =
  | {
      type: 'reinitialize';
      data: {
        sectionConfigsMap: SectionConfigsMap;
        widgetIdToSectionIdMap: WidgetsIdToSectionsIdMap;
      };
    }
  | {
      type: 'update-section-config';
      data: {
        sectionId: string;
        config: SectionWidgetConfig;
      };
    };

export const sectionWidgetConfigContextReducer: React.Reducer<State, Action> = (
  state: State,
  { type, data }: Action,
) => {
  switch (type) {
    case 'reinitialize': {
      const sectionConfigsMap = new Map(data.sectionConfigsMap);
      const widgetIdToSectionIdMap = new Map(data.widgetIdToSectionIdMap);

      // Preserve existing shared step configs, to prevent losing user changes
      state.sectionConfigsMap.forEach((sectionConfig, sectionId) => {
        if (sectionConfigsMap.has(sectionId)) {
          sectionConfigsMap.set(sectionId, {
            ...sectionConfigsMap.get(sectionId),
            sharedStep: sectionConfig.sharedStep,
          });
        }
      });

      return {
        sectionConfigsMap,
        widgetIdToSectionIdMap,
      };
    }

    case 'update-section-config': {
      const { sectionId, config } = data;

      return {
        sectionConfigsMap: new Map(state?.sectionConfigsMap).set(sectionId, config),
        widgetIdToSectionIdMap: new Map(state.widgetIdToSectionIdMap),
      };
    }

    default:
      return state;
  }
};
